/**
 * Ограничение
 */
export type Restriction = {
	name: string
	value?: number
}

/**
 * Объект(ы) с описанием ограничений
 */
export type SecurityObject = {
	object: string | string[]
	restriction?: Restriction
}

/**
 * Код, представляющий результат проверки доступа пользователя
 */
export enum UserAccessRestrictionCode {
	/** Требуется вход в систему */
	LOGIN_IS_REQUIRED,
	/** Требуется сменить пароль */
	PASSWORD_CHANGE_IS_REQUIRED,
	/** Нет доступа */
	NO_ACCESS,
	/** Есть доступ */
	ACCESS_IS_ALLOWED,
	/** Сессия истекла */
	SESSION_EXPIRED,
}

export type UserAccessRestrictionQueryParams = {
	objects?: string | SecurityObject | SecurityObject[]
	ignoreNotChangedPassword?: boolean
	secureOp?: "and" | "or"
}

/**
 * Статус доступа пользователя
 */
export interface UserAccessRestrictionStatus {
	code: UserAccessRestrictionCode
	objectIndex?: number
	isPending: boolean
}

export * from "./user"
